import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, isString, forEach, isEmpty, reduce, includes, values, isEqual } from 'lodash';
import { lifecycle, compose } from 'recompose';
import { createStructuredSelector } from 'reselect'
import * as selectors from '../selectors';


import RecallsListView from '../views/recalls-list';
import * as actions from '../actions';

const withConnect = connect(
  createStructuredSelector({
    data: selectors.getSearchResults,
    availableFacets: selectors.getSearchUiFacets,
    expandedFacetBlocks: selectors.getSearchExpandedFacetBlocks,
    facetSpotlightSearches: selectors.getSearchFacetSpotlights,
    responseInfo: selectors.getSearchResponseInfo,
    isFething: selectors.getSearchIsFetching,
    loadedQuery: selectors.getSearchLoadedQuery,
    dates: selectors.getSearchDatesRange,
    selectedFacets: selectors.getSearchSelectedFacetIds,
    sort: selectors.getSearchSortBy,
    order: selectors.getSearchSortOrder,
    searchTerm: selectors.getSearchTerm,
    currentPage: selectors.getSearchResultsPage,
    facetId: selectors.getSearchSegment,
    locale: selectors.getLocale,
    config: selectors.getConfig,
  }),
  { ...actions }
);

const withData = lifecycle({
  componentWillReceiveProps(nextProps) {
    const currentQuery = this.props.location.query;
    const nextQuery = nextProps.location.query;
    if (!isEqual(currentQuery, nextQuery)) {
      this.props.fetchRecalls(nextQuery);
    }
  },
  componentDidMount() {
    const currentQuery = this.props.location.query;
    const loadedQuery = this.props.loadedQuery;
    if (!isEqual(currentQuery, loadedQuery))
      this.props.fetchRecalls(currentQuery);
  }
});

export default compose(
  withConnect,
  withData,
)((RecallsListView));



// WEBPACK FOOTER //
// ./src/containers/recalls-list.js